import React from 'react';

import { createStyles } from "../BrowsingCard/styles";
import BrowsingCardName from "../common/BrowsingCardName";
import CarrierLogo from "../common/CarrierLogo";
import ProductRates from "../common/ProductRates";










var BrowsingMultiProduct = function BrowsingMultiProduct(_ref)






{var product = _ref.product,isPortfolioInProposal = _ref.isPortfolioInProposal,isMultiProductPortfolio = _ref.isMultiProductPortfolio,showMobileLayoutVersion = _ref.showMobileLayoutVersion,isDisabled = _ref.isDisabled,createProductAttributesInfo = _ref.createProductAttributesInfo;
  var classes = createStyles({
    isPortfolioInProposal: isPortfolioInProposal,
    isMultiProductPortfolio: isMultiProductPortfolio,
    isDisabled: isDisabled,
    showMobileLayoutVersion: showMobileLayoutVersion
  });

  var imProductId = product.imProductId,carrier = product.carrier,productDisplayName = product.productDisplayName,bcDependentData = product.bcDependentData,productLine = product.productLine;
  var currentBcInfo = bcDependentData['0'];
  var productAttributes = currentBcInfo.productAttributes,rates = currentBcInfo.rates;

  return /*#__PURE__*/(
    React.createElement("div", { className: classes.multiProductWrapper, id: imProductId, key: imProductId }, /*#__PURE__*/

    React.createElement("div", { className: classes.multiCardHeader }, /*#__PURE__*/
    React.createElement(CarrierLogo, { carrier: carrier })), /*#__PURE__*/

    React.createElement("div", { className: classes.multiProductTopInfo }, /*#__PURE__*/
    React.createElement(BrowsingCardName, {
      name: productDisplayName,
      wrapperStyles: classes.multiProductNameWrapper,
      isPortfolioInProposal: isPortfolioInProposal,
      showSelectedIcon: false }), /*#__PURE__*/


    React.createElement(ProductRates, { id: imProductId, rates: rates, styles: classes.ratesList })),


    createProductAttributesInfo(productAttributes, productLine)));


};

export default BrowsingMultiProduct;
//# sourceMappingURL=index.js.map